import { ModalView } from './view';
import { EventEmitterFactory } from '../event/emitter.factory';
import { BrowserDocumentService } from '../../service/browser-document/service';
import { WindowService } from '../../service/window/service';

export function ModalViewFactory(): ModalView {
  return new ModalView(EventEmitterFactory(), BrowserDocumentService(), WindowService());
}
